import { useEffect } from "react";

// 이벤트 참가가 자원봉사자 전용(events/views.py: EventReservations.post)이라
// 일반 멤버가 신청을 시도했을 때 뜨는 안내 모달.
// 자원봉사 신청서 상태에 따라 안내 문구와 주 버튼 라벨이 달라진다.
const COPY = {
    none: {
        body: "Only volunteers can register for events. Submit a volunteer application to join us.",
        action: "Apply as a volunteer",
    },
    pending: {
        body: "Only volunteers can register for events. Your volunteer application is waiting for approval.",
        action: "View my application",
    },
    rejected: {
        body: "Only volunteers can register for events. Your previous application was not approved, but you can apply again.",
        action: "Re-apply",
    },
};

export default function VolunteerRequiredModal({ status, onApply, onClose }) {
    // 배경 스크롤 잠금.
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, []);

    const copy = COPY[status] || COPY.none;

    return (
        <div style={overlayStyle} role="presentation">
            <div
                style={panelStyle}
                role="dialog"
                aria-modal="true"
                aria-labelledby="volunteer-required-title"
            >
                <h2 id="volunteer-required-title" style={titleStyle}>
                    Volunteers only
                </h2>
                <p style={bodyStyle}>{copy.body}</p>
                <button type="button" style={primaryButtonStyle} onClick={onApply} autoFocus>
                    {copy.action}
                </button>
                <button type="button" style={secondaryButtonStyle} onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
}

const overlayStyle = {
    position: "fixed",
    inset: 0,
    background: "rgba(6, 8, 11, 0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "1rem",
};

const panelStyle = {
    background: "#ffffff",
    borderRadius: "14px",
    maxWidth: "380px",
    width: "100%",
    padding: "2rem 1.75rem",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.25)",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
};

const titleStyle = {
    margin: 0,
    fontSize: "1.375rem",
    color: "#06080b",
};

const bodyStyle = {
    margin: "0.75rem 0 1.5rem",
    fontSize: "0.95rem",
    lineHeight: 1.5,
    color: "#495460",
};

const primaryButtonStyle = {
    display: "inline-block",
    width: "100%",
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    fontWeight: 600,
    color: "#ffffff",
    background: "#8a6d3b",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
};

const secondaryButtonStyle = {
    display: "inline-block",
    width: "100%",
    marginTop: "0.625rem",
    padding: "0.75rem 1rem",
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#495460",
    background: "transparent",
    border: "1px solid #d6d9dd",
    borderRadius: "8px",
    cursor: "pointer",
};
